enum LayoutEnum {
  Market = 'Market',
  Quote = 'Quote',
}

export default LayoutEnum
